import { forwardRef } from "react";
import { cn } from "@/lib/cn";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  leading?: React.ReactNode;
  trailing?: React.ReactNode;
  invalid?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, leading, trailing, invalid, ...props }, ref) => (
    <div
      className={cn(
        "group flex h-9 items-center gap-2 rounded-sm border bg-surface px-2.5 text-sm",
        "border-line-strong transition-colors",
        "focus-within:border-brand focus-within:ring-2 focus-within:ring-[color:var(--color-brand)]/15",
        invalid && "border-danger focus-within:border-danger focus-within:ring-[color:var(--color-danger)]/15",
        className,
      )}
    >
      {leading ? (
        <span className="shrink-0 text-ink-faint [&_svg]:size-4">{leading}</span>
      ) : null}
      <input
        ref={ref}
        className="min-w-0 flex-1 bg-transparent text-ink outline-none placeholder:text-ink-faint"
        {...props}
      />
      {trailing ? <span className="shrink-0 text-ink-faint">{trailing}</span> : null}
    </div>
  ),
);
Input.displayName = "Input";

export function FieldLabel({
  children,
  htmlFor,
  hint,
  className,
}: {
  children: React.ReactNode;
  htmlFor?: string;
  hint?: React.ReactNode;
  className?: string;
}) {
  return (
    <label
      htmlFor={htmlFor}
      className={cn(
        "mb-1.5 flex items-baseline justify-between gap-3 text-xs font-medium text-ink-soft",
        className,
      )}
    >
      {/* Nhãn không được co khi có gợi ý: gợi ý dài chỉ được xuống dòng bên phải, không bóp nhãn thành từng chữ một dòng.
          Không có gợi ý thì nhãn dài được xuống dòng — cấm xuống dòng là nó đè lên nhãn ô bên cạnh (19/09/2026). */}
      <span className={hint ? "shrink-0" : "min-w-0"}>{children}</span>
      {hint ? <span className="min-w-0 text-right text-ink-faint">{hint}</span> : null}
    </label>
  );
}
